import Box from '@zenbusiness/zui/Box';
import FormHelperText from '@zenbusiness/zui/FormHelperText';
import FormLabel from '@zenbusiness/zui/FormLabel';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const FieldLabel = superstyled({
  name: 'MultiSelectField',
  slot: 'FieldLabel',
  tag: FormLabel,
  styles: ({ theme }) => ({
    marginBlockEnd: theme.spacing(0),
    // Override error state color to use primary color
    '&.Mui-error': {
      color: theme.palette.primary.main
    },
    // Hide the asterisk symbol
    '& .MuiFormLabel-asterisk': {
      display: 'none'
    }
  })
});

export const FieldDescription = superstyled({
  name: 'MultiSelectField',
  slot: 'FieldDescription',
  tag: Text,
  propsAdded: {
    size: 'sm',
    color: 'secondary'
  },
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(2)
  })
});

export const OptionsContainer = superstyled({
  name: 'MultiSelectField',
  slot: 'OptionsContainer',
  tag: Box,
  propsNeeded: ['columns'],
  styles: ({ theme, columns = 1 }) => ({
    display: 'grid',
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gap: theme.spacing(1.5),

    // Responsive: collapse to 1 column on mobile
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  })
});

export const OptionCard = superstyled({
  name: 'MultiSelectField',
  slot: 'OptionCard',
  tag: Box,
  propsNeeded: ['isSelected', 'isDisabled'],
  styles: ({ theme, isSelected, isDisabled }) => ({
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    padding: theme.spacing(1.25, 2),
    borderRadius: theme.spacing(1.5),
    border: '1px solid',
    borderColor: isSelected ? theme.palette.info.main : theme.palette.divider,
    backgroundColor: isDisabled ? theme.palette.action.disabledBackground : 'transparent',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    transition: 'border-color 0.2s ease',

    '&:hover': {
      borderColor: (() => {
        if (isDisabled) return theme.palette.divider;
        if (isSelected) return theme.palette.info.main;
        return theme.palette.primary.light;
      })()
    }
  })
});

export const CheckboxWrapper = superstyled({
  name: 'MultiSelectField',
  slot: 'CheckboxWrapper',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),

    '& .MuiCheckbox-root': {
      padding: 0
    }
  })
});

export const OptionContent = superstyled({
  name: 'MultiSelectField',
  slot: 'OptionContent',
  tag: Box,
  styles: () => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  })
});

export const OptionSuperscript = superstyled({
  name: 'MultiSelectField',
  slot: 'OptionSuperscript',
  tag: Text,
  propsAdded: {
    size: 'xs',
    color: 'secondary'
  },
  styles: () => ({
    lineHeight: 1.4
  })
});

export const OptionLabel = superstyled({
  name: 'MultiSelectField',
  slot: 'OptionLabel',
  tag: Text,
  propsAdded: {
    size: 'md'
  },
  styles: ({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    lineHeight: 1.5
  })
});

export const OptionSubtitle = superstyled({
  name: 'MultiSelectField',
  slot: 'OptionSubtitle',
  tag: Text,
  propsAdded: {
    size: 'sm',
    color: 'secondary'
  },
  styles: ({ theme }) => ({
    marginTop: theme.spacing(0.25),
    lineHeight: 1.4
  })
});

export const FieldHelperText = superstyled({
  name: 'MultiSelectField',
  slot: 'FieldHelperText',
  tag: FormHelperText,
  styles: ({ theme }) => ({
    marginTop: theme.spacing(1.5)
  })
});
